import layout_bottom_withLogo from './layout_bottom_withLogo.jpg'
import layout_top from './layout_top.jpg'
import layout_bottom_withoutLogo from './layout_bottom_withoutLogo.jpg'

const media = {
    layout_bottom_withLogo,
    layout_top,
    layout_bottom_withoutLogo
}
export default media